import { render, staticRenderFns } from "./EvalAdministrative.vue?vue&type=template&id=45bad613"
import script from "./EvalAdministrative.vue?vue&type=script&lang=js"
export * from "./EvalAdministrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports